import React, { Component } from "react";
import styled from "styled-components";

class TitleWithContent extends Component {
  render() {
    const {
      title,
      children
    } = this.props;
    return (
      <TitleWithContentContainer>
        <strong>
          <span>
            &#9632; 
          </span>
          {title}
        </strong>
        {children}
      </TitleWithContentContainer>
    )
  }
}
const TitleWithContentContainer = styled.div`
  display: flex;
  flex-direction: column;

  & > strong {
    font-size: 16px;
    font-weight: bold;
    height: 16px;
    margin-bottom: 10px;
  }
  
  & > strong > span {
    margin-right: 10px;
  }
`;

export default TitleWithContent;